// import TravelerChoices from "components/sectionWrapper/TravelerChoices";
import TourPackageOptions from "../TourPackageOptions";

export default function Choices({
  showPopup,
  handleChange,
  formErrors,
  formData,
  onOptionChange,
  onChoiceChange,
  setFormErrors,
  submitRef,
  allParticipantsData,
  isInvited,
}) {
  return (
    <div ref={submitRef} className="scroll-m-28">
      <TourPackageOptions
        showPopup={showPopup}
        formData={formData}
        handleChange={handleChange}
        formErrors={formErrors}
        onOptionChange={onOptionChange}
        setFormErrors={setFormErrors}
        allParticipantsData={allParticipantsData}
        isInvited={isInvited}
      />

      {/* <TravelerChoices
        formData={formData}
        handleChange={handleChange}
        formErrors={formErrors}
        onChoiceChange={onChoiceChange}
        setFormErrors={setFormErrors}
      /> */}
    </div>
  );
}
